import classNames from 'classnames';
import React, { ReactNode } from 'react';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

interface IProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  footer?: JSX.Element;
  title?: string;
  size?: string;
  actions?: JSX.Element;
  nopadding?: boolean;
  className?: string;
  header?: boolean;
  footerClass?: boolean;
  testId?: string;
  id?: string;
}

const sizeClasses: Record<string, string> = {
  sm: 'max-w-sm',
  md: 'max-w-lg',
  lg: 'max-w-3xl',
  xl: 'max-w-5xl',
};

const ModalContainer = ({
  children,
  isOpen = false,
  onClose,
  size = 'md',
  footer,
  title,
  actions,
  nopadding = false,
  className = '',
  header = true,
  footerClass = false,
  testId = '',
  id = '',
}: IProps): JSX.Element => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent
        // `backdrop="static"` + `keyboard={false}` parity: prevent closing on
        // outside-click or Escape so the modal only closes via the × / actions.
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className={classNames(
          sizeClasses[size] ?? sizeClasses.md,
          nopadding && 'p-0',
          className
        )}
        data-testid={testId}
        id={id}
      >
        {header ? (
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            {actions && <div>{actions}</div>}
          </DialogHeader>
        ) : (
          // Radix requires a title for accessibility even when one isn't shown.
          <DialogTitle className="sr-only">{title || 'Dialog'}</DialogTitle>
        )}
        <div
          className={classNames(
            nopadding ? 'p-0' : '',
            'body-subtext-regular',
            !header && 'rounded-md'
          )}
        >
          {children}
        </div>
        {footer && (
          <DialogFooter
            className={classNames(
              'modal-footer',
              footerClass ? 'block justify-between' : ''
            )}
          >
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};
export default ModalContainer;
